// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.communicationtemplate.AdminUpdatePracticeTemplateRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminUpdatePracticeTemplateRequest extends GandalfModelBase {

	@GandalfLabel('Bottom Margin')
	@GandalfValidator({ notNull: { message: 'Bottom Margin is required' } })
	@GandalfValidator({ min: { min: 0, message: 'Bottom Margin must be greater than or equal to 0 inches' } })
	@GandalfValidator({ max: { max: 5, message: 'Bottom Margin must be less than or equal to 5 inches' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	bottomMargin!: number;

	@GandalfLabel('Content')
	@GandalfValidator({ notNull: { message: 'Content is required' } })
	@GandalfValidator({ sizeString: { message: 'Content must be between 1 and 65535 characters', minLength: 1, maxLength: 65535 } })
	@GandalfProperty({ designType: String, isRequired: true })
	content!: string;

	@GandalfLabel('Description')
	@GandalfValidator({ sizeString: { message: 'Description cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfLabel('Fulfills PCP Communication CQM')
	@GandalfValidator({ notNull: { message: 'Fulfills PCP Communication CQM is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	fulfillsPcpCommunicationCqm!: boolean;

	@GandalfLabel('Left Margin')
	@GandalfValidator({ notNull: { message: 'Left Margin is required' } })
	@GandalfValidator({ min: { min: 0, message: 'Left Margin must be greater than or equal to 0 inches' } })
	@GandalfValidator({ max: { max: 4, message: 'Left Margin must be less than or equal to 4 inches' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	leftMargin!: number;

	@GandalfLabel('Name')
	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfLabel('Practice Template')
	@GandalfValidator({ notNull: { message: 'Practice Template is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceTemplateId!: number;

	@GandalfLabel('Right Margin')
	@GandalfValidator({ notNull: { message: 'Right Margin is required' } })
	@GandalfValidator({ min: { min: 0, message: 'Right Margin must be greater than or equal to 0 inches' } })
	@GandalfValidator({ max: { max: 4, message: 'Right Margin must be less than or equal to 4 inches' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	rightMargin!: number;

	@GandalfLabel('Top Margin')
	@GandalfValidator({ notNull: { message: 'Top Margin is required' } })
	@GandalfValidator({ min: { min: 0, message: 'Top Margin must be greater than or equal to 0 inches' } })
	@GandalfValidator({ max: { max: 5, message: 'Top Margin must be less than or equal to 5 inches' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	topMargin!: number;

}
